<template>
  <!-- Item của combo không có column -->
  <li
    class="combobox-item single"
    :class="{'parent':item.is_parent}"
    :style="'text-align: '+align"
    v-if="comboType === 1"
    v-on="listeners"
  >
    <div class="combobox-item-con">
      <div class="combobox-item--text" :title="getItemDisplay(item)">{{ getItemDisplay(item)}}</div>
      <span class="trash-icon" v-if="hasRemoveItemButton" @click="onRemoveItemClick()">
        <span class="mi mi-16 mi-garbage"></span>
      </span>
	  <div class="selected-container" v-if="item.multiSelected || isSelected">
		<div :class="['icon24','mi-checkbox-active']" ></div>
	  </div>
    </div>
  </li>
  <li
    class="combobox-item single"
    :class="{'parent':item.isParent}"
    :style="'text-align: '+align"
    v-else-if="comboType === 3 && columnx.length == 0"
    v-on="listeners"
	:data="JSON.stringify(item)"
  >
    <div class="combobox-item-con">
      <div
        class="combobox-item--text"
        :class="`level-${item.level}`"
        :title="getItemDisplay(item)"
      >{{ getItemDisplay(item)}}</div>
      <span class="trash-icon" v-if="hasRemoveItemButton" @click="onRemoveItemClick()">
        <span class="mi mi-16 mi-garbage"></span>
      </span>
    </div>
	<div class="selected-container" v-if="item.multiSelected || isSelected">
		<div :class="['icon24','mi-checkbox-active']" ></div>
	</div>
  </li>
  <!-- Item của combo có column -->
  <tr class="combobox-item" :class="{'parent':item.isParent}" v-else v-on="listeners">
    <td
      class="combobox-item-td"
      v-for="(column, tdIndex) in columnx"
      :ref="`td-${tdIndex}`"
      :key="column.dataField"
      :class="(comboType === 3 && tdIndex === 0) ? `level-${item.level}` : null"      
    >
      <div class="combobox-item-td--contents" :style="getCellStyle(column,tdIndex)">
        <div
          :title="getItemDisplay(item, column)"
          class="combobox-item-td--text"
        >{{ getItemDisplay(item, column) }}</div>
      </div>
    </td>
    <td class="selected-container" >
      <div :class="['icon24','mi-checkbox-active']" v-if="item.multiSelected || isSelected"></div>
    </td>
  </tr>
</template>

<script>
export default {
	name: 'MsComboBoxItem',
	props: {
		/**
		 * Loại combo
		 */
		comboType: {
			type: Number,
			default: 1
		},

		/**
		 * Item sử dụng để binding
		 */
		item: {},

		/**
		 * Cấu hình cột của menu
		 */
		columnx: {
			type: Array,
			default: []
		},
		/**
		 * Trường làm value
		 * CreatedBy PDKIEN 10/12/2019
		 */
		valueField: {
			type: String,
			default: null
		},
		/**
		 * Trường là display
		 * CreatedBy PDKIEN 10/12/2019
		 */
		displayField: {
			type: String,
			default: null
		},

		/**
		 * Trạng thái có btn `Xóa` trong item
		 */
		hasRemoveItemButton: {
			type: Boolean,
			default: false
		},
		/**
		 * Kiểu định dạng dữ liệu trên combobox
		 * Tương ứng với FormatType
		 * CreatedBy PDKIEN 07/12/2019
		 */
		formatType: {
			type: [Number, String],
			default: null
		},
		align: {
			type: String,
			default: 'left'
		},
		/**
		 * có đang được chọn hay không
		 */
		isSelected:{
			type: Boolean,
			default: false
		},
	},
	computed: {
		/**
		 * Binding sự kiện của menu item
		 */
		listeners() {
			let me = this;
			return {
				...me.$listeners
			};
		}
	},
	methods: {
		/**
		 * Hàm lấy style cho td trong table
		 * dữ liệu động theo config của dev
		 */
		getCellStyle(column, index) {
			if (column.isResize) {
				if (this.$refs[`td-${index}`] && this.$refs[`td-${index}`].length > 0) {
					let item = this.$refs[`td-${index}`][0];
					let rectTd = item.getBoundingClientRect();
					let rectParent = this.$parent.$el.getBoundingClientRect();
					if (rectTd.right <= rectParent.right) {
						return {
							width: rectTd.width + (rectParent.right - rectTd.right) + 'px',
							textAlign: column.columnAlign
						};
					} else {
						return {
							width: `${column.width}px`,
							textAlign: column.columnAlign
						};
					}
				}
			}
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.columnAlign
			};
		},

		/**
		 * Lấy text hiển thị trên item
		 * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
		 * CreatedBy PDKIEN 10/12/2019
		 */
		getItemDisplay(item, column) {
			let field = column
				? column.dataField
				: this.displayField || this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		/**
		 * Xử lý sự kiện khi click icon xóa item
		 */
		onRemoveItemClick() {
			this.$emit('removeItem');
		}
	}
};
</script>

<style lang="scss" scoped>
// @media screen and (max-width: 1366px) {
// 	@import '@/assets/scss/_sm-variables.scss';
// 	@import '@/assets/scss/components/MsComboboxItem.scss';
// }
// @media screen and (min-width: 1367px) {
// 	@import '@/assets/scss/_variables.scss';
// 	@import '@/assets/scss/components/MsComboboxItem.scss';
// }
@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/MsComboboxItem.scss';
</style>
